import DisplayData from 'portaltransparencia-common/components/displaydata/DisplayData.react.js';
import DisplayDataItem from 'portaltransparencia-common/components/displaydata/DisplayDataItem.react.js';
import DisplayDataRow from 'portaltransparencia-common/components/displaydata/DisplayDataRow.react.js';
import { List } from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';
import Panel from 'portaltransparencia-common/components/Panel.react';

const PROGRAMATICA_FIELDS = [
  {
    title: 'Órgão',
    path1: ['unidade', 'unidadeSuperior', 'codigo'],
    path2: ['unidade', 'unidadeSuperior', 'descricao']
  },
  {
    title: 'Unidade',
    path1: ['unidade', 'codigo'],
    path2: ['unidade', 'descricao']
  },
  {
    title: 'Função',
    path1: ['funcao', 'codigo'],
    path2: ['funcao', 'descricao']
  },
  {
    title: 'SubFunção',
    path1: ['subfuncao', 'codigo'],
    path2: ['subfuncao', 'descricao']
  },
  {
    title: 'Programa',
    path1: ['programa', 'codigo'],
    path2: ['programa', 'descricao']
  },
  {
    title: 'Projeto Atividade',
    path1: ['projetoAtividade', 'codigo'],
    path2: ['projetoAtividade', 'descricao']
  },
  {
    title: 'Despesa',
    path1: ['despesa', 'formattedCodigo'],
    path2: ['despesa', 'descricao']
  }
];

export default function FormDetailDotacoes({ dotacoes }) {
  const items = dotacoes || List();

  if (items.size === 0) {
    return (
      <p className="text-muted">
        Nenhuma Classificação Orçamentária informada.
      </p>
    );
  }

  return (
    <React.Fragment>
      {items.map((item, index) => {
        const dotacao = item.get('dotacao');
        const fonteRecurso = item.get('fonteRecurso');
        const despesa = item.get('despesa');

        return (
          <React.Fragment key={index}>
            <div className="panel-inside-panel mt-xs">
              <Panel
                insidePanel
                title="Detalhes da Programática"
                isTable
                tableResponsive
              >
                <DisplayData border>
                  {PROGRAMATICA_FIELDS.map(field => (
                    <DisplayDataRow key={field.title}>
                      <DisplayDataItem
                        sm={12}
                        title={field.title}
                        value={dotacao?.getIn(field.path1) || '-'}
                        value2={dotacao?.getIn(field.path2) || ''}
                      />
                    </DisplayDataRow>
                  ))}
                </DisplayData>
              </Panel>
            </div>

            <div className="mt-xs">
              <DisplayData border>
                <DisplayDataRow>
                  <DisplayDataItem
                    sm={6}
                    title="Despesa"
                    value={despesa?.get('formattedCodigo')}
                    value2={despesa?.get('descricao')}
                  />
                  <DisplayDataItem
                    sm={6}
                    title="Fonte de Recurso"
                    value={fonteRecurso?.get('codigo')}
                    value2={fonteRecurso?.get('descricao')}
                  />
                </DisplayDataRow>
              </DisplayData>
            </div>
            
            <hr className="mt-xs mb-xs" />
          </React.Fragment>
        );
      })}
    </React.Fragment>
  );
}

FormDetailDotacoes.propTypes = {
  dotacoes: PropTypes.object
};
